<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
    id="dropdown-user-menu-purple"
    menu-class="size-submenu"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name-main-navbar-up font-weight-bolder mb-0">
          {{userData ? userData.first_name || userData.first_name : ""}}
        </p>
        <span class="user-status" v-if="userData && userData.main_group">
          {{userData.main_group.name == 'espejo' ? capitalize($t('header.typeUser.personalizedService')) : getNameRol()}} 
          <span class="d-none d-xl-inline">{{ period_trial.text }}</span>
          <b-badge variant="primary" class="d-xl-none">{{ period_trial.number }}</b-badge>
        </span>
      </div>
      <b-avatar
        v-if="userData"
        size="40"
        :src="verifyAsset(userData.profile_image)"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
      <feather-icon v-if="userData && userData.profile_image === null" icon="UserIcon" size="22" class="text-white" />
      </b-avatar>
    </template>

    <b-dropdown-item link-class="menu-dropdown d-flex justify-content-start flex-column" @click="redirectEmail()">
      <span class="container-username"> {{userData ? userData.first_name || userData.first_name : ""}} {{userData ? userData.last_name || userData.last_name : "" }}</span>
      <span class="container-email"> {{userData.email}}</span>
    </b-dropdown-item>
    <b-dropdown-divider class="px-1"/>
    <b-dropdown-item
      :to="{ name: 'brandme_AI', params: { section: 'community' } }"
      link-class="menu-dropdown"
    >
      <div class="d-flex justify-content-between ">
        <div>
          <span class="">{{$t('creator.creditsIa')}}: </span>
          <small class="text-muted d-flex">{{$t('creator.remainings')}}: {{ credits >= 0 ? separatebycomma(credits) : '0'}}</small>
        </div>
        <svg class="image-icon-brandme-ia-drop" fill="currentColor"  viewBox="0 0 512.009 512.009" xmlns="http://www.w3.org/2000/svg">
          <path d="M495.617,367.387H436.84V172.604c0-9.052-7.331-16.383-16.383-16.383c-9.052,0-16.392,7.331-16.392,16.383V387 c0,9.185-9.144,16.947-20.024,17.08c-0.095-0.002-0.186-0.014-0.281-0.014c-0.178,0-0.351,0.021-0.528,0.027h-62.816 c-0.177-0.006-0.349-0.027-0.528-0.027s-0.351,0.021-0.528,0.027h-62.834c-0.177-0.006-0.349-0.027-0.527-0.027 s-0.35,0.021-0.527,0.027h-62.826c-0.177-0.006-0.349-0.027-0.527-0.027s-0.35,0.021-0.527,0.027h-62.826 c-0.177-0.006-0.349-0.027-0.527-0.027c-0.095,0-0.187,0.013-0.281,0.014c-10.889-0.133-20.024-7.895-20.024-17.08V125.045 c0-9.265,9.301-17.093,20.305-17.093H383.76c11.005,0,20.305,7.828,20.305,17.093v3.213c0,9.052,7.339,16.383,16.392,16.383 h75.16c9.052,0,16.392-7.331,16.392-16.383s-7.339-16.383-16.392-16.383h-60.659c-4.723-16.174-17.922-29.08-34.807-34.244 V25.612c0-9.052-7.339-16.383-16.392-16.383c-9.052,0-16.383,7.331-16.383,16.383v49.574h-31.106V25.612 c0-9.052-7.331-16.383-16.383-16.383c-9.052,0-16.392,7.331-16.392,16.383v49.574h-31.115V25.612 c0-9.052-7.339-16.383-16.383-16.383s-16.383,7.331-16.383,16.383v49.574h-31.115V25.612c0-9.052-7.339-16.383-16.383-16.383 s-16.383,7.331-16.383,16.383v49.574h-31.115V25.612c0-9.052-7.331-16.383-16.383-16.383s-16.383,7.331-16.383,16.383v52.016 c-16.884,5.16-30.073,18.065-34.795,34.238H16.383C7.339,111.866,0,119.196,0,128.249c0,9.052,7.339,16.383,16.383,16.383h58.786 v222.755H16.383C7.339,367.387,0,374.717,0,383.769c0,9.052,7.339,16.383,16.383,16.383H77.06 c4.721,16.173,17.91,29.083,34.796,34.246v51.999c0,9.052,7.331,16.383,16.383,16.383c9.043,0,16.383-7.331,16.383-16.383V436.84 h31.115v49.556c0,9.052,7.331,16.383,16.383,16.383c9.043,0,16.383-7.331,16.383-16.383V436.84h31.115v49.556 c0,9.052,7.331,16.383,16.383,16.383s16.383-7.331,16.383-16.383V436.84h31.115v49.556c0,9.052,7.339,16.383,16.392,16.383 c9.043,0,16.383-7.331,16.383-16.383V436.84h31.106v49.556c0,9.052,7.331,16.383,16.383,16.383 c9.052,0,16.392-7.331,16.392-16.383v-52c16.886-5.163,30.073-18.071,34.795-34.244h60.67c9.043,0,16.392-7.331,16.392-16.383 C512.009,374.717,504.669,367.387,495.617,367.387z"/>
          <path d="M495.617,303.506h-31.771c-9.052,0-16.383,7.331-16.383,16.383c0,9.052,7.331,16.383,16.383,16.383h31.771 c9.043,0,16.392-7.331,16.392-16.383C512.009,310.837,504.669,303.506,495.617,303.506z"/>
          <path d="M495.617,239.617h-31.771c-9.052,0-16.383,7.331-16.383,16.383c0,9.052,7.331,16.383,16.383,16.383h31.771 c9.043,0,16.392-7.331,16.392-16.383C512.009,246.948,504.669,239.617,495.617,239.617z"/>
          <path d="M495.617,175.737h-31.771c-9.052,0-16.383,7.331-16.383,16.383c0,9.052,7.331,16.383,16.383,16.383h31.771 c9.043,0,16.392-7.331,16.392-16.383C512.009,183.068,504.669,175.737,495.617,175.737z"/>
          <path d="M16.383,336.272h31.78c9.043,0,16.383-7.331,16.383-16.383c0-9.052-7.331-16.383-16.383-16.383h-31.78 C7.339,303.506,0,310.846,0,319.889C0,328.932,7.339,336.272,16.383,336.272z"/>
          <path d="M16.383,272.383h31.78c9.043,0,16.383-7.322,16.383-16.374c0-9.052-7.331-16.383-16.383-16.383h-31.78 C7.339,239.626,0,246.965,0,256.009C0,265.052,7.339,272.383,16.383,272.383z"/>
          <path d="M16.383,208.503h31.78c9.043,0,16.383-7.331,16.383-16.383c0-9.052-7.331-16.383-16.383-16.383h-31.78 C7.339,175.737,0,183.068,0,192.12C0,201.172,7.339,208.503,16.383,208.503z"/>
          <path d="M203.08,170.27c-6.754,0-12.815,4.136-15.265,10.428l-54.091,138.703c-3.284,8.44,0.879,17.936,9.31,21.219 c8.44,3.284,17.936-0.887,21.219-9.31l8.583-22.009h60.488l8.583,22.009c2.52,6.479,8.706,10.437,15.264,10.437 c1.979,0,3.994-0.364,5.955-1.127c8.422-3.284,12.602-12.788,9.31-21.219l-54.091-138.703 C215.886,174.406,209.834,170.27,203.08,170.27z M185.613,276.536l17.467-44.791l17.467,44.791H185.613z"/>
          <path d="M348.723,203.036c9.043,0,16.392-7.331,16.392-16.383c0-9.052-7.339-16.383-16.392-16.383H302.85 c-9.052,0-16.383,7.331-16.383,16.383c0,9.052,7.331,16.383,16.383,16.383h6.55v105.946h-6.55 c-9.052,0-16.383,7.331-16.383,16.383c0,9.052,7.331,16.383,16.383,16.383h45.873c9.043,0,16.392-7.331,16.392-16.383 c0-9.052-7.339-16.383-16.392-16.383h-6.541V203.036H348.723z"/>
        </svg>
      </div>
    </b-dropdown-item>

    <b-dropdown-item
      :to="{ name: 'analyzer'}"
      link-class="d-flex align-items-start menu-dropdown justify-content-between cursor-pointer"
      v-if="userData.main_group && userData.main_group.name !== 'creator'"
    >
      <div>
        <span>{{$t('reportsInfluencers')}} </span>
        <small class="text-muted d-flex">{{$t('creator.remainings')}}: {{ separatebycomma(max_view) }}</small>
      </div>
    </b-dropdown-item>
      <b-dropdown-divider class="px-1"/>
      <b-dropdown-item
        :to="{ name: 'dashboard-analytics'}"
        link-class="d-flex align-items-center menu-dropdown"
      >
        <feather-icon size="16" icon="HomeIcon" class="mr-50" />
        <span>{{ $t("dashboard.desk") }}</span>
      </b-dropdown-item>
      <b-dropdown-item v-if="userData.main_group && userData.main_group.name==='creator'"
        :to="{ name: 'my_work-without-section', params: { section: 'networks' } }"
        link-class="d-flex align-items-center menu-dropdown"
      >
        <feather-icon size="16" icon="LinkIcon" class="mr-50" />
        <span>{{ $t("header.userMenu.network") }}</span>
      </b-dropdown-item>
      <b-dropdown-item v-else-if="userData.main_group && userData.main_group.name==='whitelabel'"
        :to="{ name: 'pages-account-setting', params: { section: 'social' } }"
        link-class="d-flex align-items-center menu-dropdown"
      >
        <feather-icon size="16" icon="LinkIcon" class="mr-50" />
        <span>{{ $t("header.userMenu.network") }}</span>
      </b-dropdown-item>
      <b-dropdown-item  link-class="d-flex align-items-center menu-dropdown"
        v-if="!showStatus() && !checkOutHome()"
        :to="{ name: 'my_work-without-section', params: { section: 'transactions' } }"
      >
        <feather-icon size="16" icon="CreditCardIcon" class="mr-50" />
        <span>{{ $t("header.userMenu.transaction") }}</span>
      </b-dropdown-item>
      <b-dropdown-item 
        link-class="d-flex align-items-center menu-dropdown"
        :to="{ name: 'pages-account-setting', params: { section: 'membership' }}"
      >
        <b-icon
          icon="card-checklist"
          size="18"
          class="mr-50"
        />
        <span>{{$t('membership')}}</span>
      </b-dropdown-item>
      <b-dropdown-item
        :to="{ name: 'pages-account-setting', params: { section: 'general' } }"
        link-class="d-flex align-items-center menu-dropdown"
      >
        <feather-icon size="16" icon="SettingsIcon" class="mr-50" />
        <span>{{ $t("header.userMenu.settings") }}</span>
      </b-dropdown-item>

       <b-dropdown-divider class="px-1" v-if="showStatus() && !checkOutHome()"/>
      <b-dropdown-item link-class="d-flex align-items-center menu-dropdown" href="https://brandme.statuspage.io/" target="_blank" v-if="showStatus() && !checkOutHome()">
        <feather-icon
          size="16"
          icon="BarChartIcon"
          class="mr-50"
          variant="light-primary"
        />
        <span>{{$t('header.userMenu.status')}}</span>
      </b-dropdown-item>
      <b-dropdown-divider class="px-1"  v-if="!showStatus() && !checkOutHome()"/>

      <b-button
        :class="`${visible ? null : 'collapsed'} custom-drop align-items-start d-flex`"
        variant="custom-drop"
        :aria-expanded="visible ? 'true' : 'false'"
        @click="visible = !visible"
      >
      <b-img :src="`${$i18n.locale === 'en' ? locales.en.img : locales.es.img }`" width="16px" :alt="locales.en.locale" />
      <span class="ml-07">{{ this.$i18n.locale === 'en' ? locales.en.name : locales.es.name}}</span>
      </b-button>
    <b-collapse v-model="visible" class="mt-1">
      <div>
        <b-dropdown-item @click="changeLanguage('en')">
          <b-img :src="locales.en.img" width="16px" :alt="locales.en.locale" />
          <span class="ml-07">{{ locales.en.name }}</span>
        </b-dropdown-item>
        <b-dropdown-item @click="changeLanguage('es')">
          <b-img :src="locales.es.img" width="16px" :alt="locales.es.locale" />
          <span class="ml-07">{{ locales.es.name }}</span>
        </b-dropdown-item>
      </div>
    </b-collapse>


      <b-dropdown-divider class="px-1"/>
      <div class="d-flex align-items-center px-2 py-1"
        v-if="!checkOutHome()"
      >
        <span class="container-submenu">{{ $t("header.userMenu.support&Help") }}</span>
      </div>
      <b-dropdown-item link-class="d-flex align-items-center menu-dropdown"
        v-if="!checkOutHome()" href="https://soporte.brandme.la/" target="_blank"
      >
      <div class="d-flex">
        <svg
          class="image-icon-brandme-ia-drop knowledge-base-icon"
          viewBox="0 0 512.002 512.002"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          aria-hidden="true"
        >
          <g>
            <path d="M449.786 267.314h-73.058c-9.697 0-9.697 15 0 15h73.058c9.698 0 9.698-15 0-15z" />
            <path d="M449.786 311.443h-73.058c-9.697 0-9.697 15 0 15h73.058c9.698 0 9.698-15 0-15z" />
            <path d="M449.786 355.573h-73.058c-9.697 0-9.697 15 0 15h73.058c9.698 0 9.698-15 0-15z" />
            <path d="M449.786 399.702h-73.058c-9.697 0-9.697 15 0 15h73.058c9.698 0 9.698-15 0-15z" />
            <path d="M267.298 399.702h-73.058c-9.697 0-9.697 15 0 15h73.058c9.697 0 9.697-15 0-15z" />
          </g>
          <path d="M78.122 322.827c-4.142 0-7.5 3.357-7.5 7.5v12.391c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-12.391c0-4.143-3.358-7.5-7.5-7.5z" />
          <path d="M480.648 201.906H359.886c-15.81 0-29.75 8.134-37.876 20.431-3.717-5.647-8.683-10.476-14.617-14.025v-1.987c9.213-3.902 15.692-13.035 15.692-23.654v-14.064c28.496-15.663 46.663-46.08 46.663-78.786 0-24.826-10.419-48.777-28.587-65.712-18.42-17.173-42.466-25.649-67.707-23.879-13.64.959-26.58 4.949-38.46 11.86-8.383 4.876-.839 17.841 7.542 12.966 9.881-5.748 20.637-9.066 31.97-9.863 21.038-1.479 41.083 5.583 56.428 19.887 15.135 14.108 23.815 34.061 23.815 54.74 0 28.577-16.649 55.056-42.416 67.458-2.596 1.25-4.247 3.876-4.247 6.758v18.634c0 5.885-4.788 10.673-10.673 10.673h-9.982v-73.99c9.179-1.532 17.643-5.856 24.361-12.575 6.858-6.857-3.75-17.463-10.606-10.606-5.683 5.683-13.232 8.813-21.255 8.813s-15.571-3.13-21.254-8.813c-6.856-6.858-17.463 3.75-10.606 10.606 6.718 6.719 15.182 11.043 24.361 12.575v73.99h-9.982c-5.885 0-10.673-4.788-10.673-10.673v-18.634c0-2.881-1.651-5.508-4.247-6.758-27.802-13.382-44.378-41.971-42.228-72.834.873-12.535 5-24.764 11.933-35.366 5.307-8.116-7.246-16.325-12.554-8.21-8.333 12.742-13.292 27.45-14.343 42.534-.22 3.161-.269 6.301-.167 9.413-4.359-1.576-8.992-2.405-13.693-2.405-13.495 0-25.451 6.681-32.759 16.901-7.308-10.22-19.265-16.901-32.759-16.901-22.199 0-40.259 18.06-40.259 40.259 0 .325 0 .681-.001 1.058-20.429 2.822-36.209 20.397-36.209 41.589v15.437c-19.59 3.547-34.49 20.723-34.49 41.315v22.506c0 20.592 14.9 37.769 34.485 41.314v15.437c0 21.187 15.774 38.758 36.209 41.587.001.378.002.735.002 1.06 0 22.199 18.06 40.259 40.259 40.259 7.719 0 14.935-2.188 21.068-5.97v94.387c0 17.289 14.065 31.354 31.354 31.354h247.623c9.697 0 9.697-15 0-15h-80.549c3.348-13.132 15.274-22.873 29.434-22.873h137.115v6.52c0 9.018-7.336 16.354-16.354 16.354h-30.4c-9.697 0-9.697 15 0 15h30.4c17.289 0 31.354-14.065 31.354-31.354v-247.389c0-17.289-14.065-31.354-31.353-31.354zm-344.432 150.067c0 13.928-11.331 25.259-25.259 25.259s-25.259-11.331-25.259-25.259c0-2.743-.053-21.825-.053-21.825 0-9.697-15-9.697-15 0v5.522c-12.087-2.672-21.158-13.466-21.158-26.345v-26.71c0-13.164 10.709-23.873 23.873-23.873s23.873 10.709 23.873 23.873v14.628c0 9.697 15 9.697 15 0v-14.628c0-21.435-17.438-38.873-38.873-38.873-20.062 0-36.621 15.277-38.659 34.809-11.35-3.188-19.698-13.623-19.698-25.978v-22.506c0-14.88 12.105-26.985 26.985-26.985 11.027 0 22.437.229 33.58.229 20.217 0 36.665-16.448 36.665-36.665 0-9.697-15-9.697-15 0 0 11.419-8.882 20.797-20.1 21.602-.505-.107-1.028-.166-1.565-.166h-26.08v-14.766c0-14.879 12.105-26.985 26.985-26.985 6.842 0 13.694.073 20.539.073 9.697 0 9.697-15 0-15h-11.315c.001-.257.001-.506.001-.735 0-13.928 11.331-25.259 25.259-25.259s25.259 11.331 25.259 25.259zm131.251-143.629h24.927v17.615c0 3.861-3.142 7.003-7.003 7.003h-10.921c-3.861 0-7.003-3.142-7.003-7.003zm-116.251-77.674c0-13.928 11.331-25.259 25.259-25.259 5.935 0 11.692 2.099 16.227 5.906 1.714 7.017 4.258 13.755 7.556 20.088h-9.807c-9.697 0-9.697 15 0 15h18.835c.262 0 .522-.014.777-.04 7.23 8.92 16.234 16.517 26.711 22.248 0 6.304-.758 13.263.579 19.47h-25.489c-11.649 0-21.665-9.452-21.665-21.436 0-9.697-15-9.697-15 0 0 20.217 16.448 36.665 36.665 36.665 11.115 0 23.965 1.566 34.883-.349 1.744 1.352 3.661 2.49 5.719 3.362v19.634c0 11.444 8.784 20.872 19.963 21.905v4.711c0 12.355-8.349 22.789-19.698 25.978-2.039-19.531-18.598-34.809-38.66-34.809-21.435 0-38.873 17.438-38.873 38.873v14.628c0 9.697 15 9.697 15 0v-14.628c0-13.164 10.709-23.873 23.873-23.873s23.873 10.709 23.873 23.873v26.71c0 12.901-9.102 23.71-21.219 26.359v-5.421c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5c0 0 .008 18.825.008 21.709 0 13.928-11.331 25.259-25.259 25.259s-25.259-11.331-25.259-25.259v-221.304zm12.163 366.332c-9.018 0-16.354-7.336-16.354-16.354v-6.52h137.115c14.16 0 26.086 9.741 29.434 22.873h-150.195zm151.134-26.179c-8.048-7.264-18.703-11.693-30.373-11.693H228.186v-79.746c7.355 7.897 17.833 12.849 29.45 12.849 15.491 0 28.958-8.8 35.687-21.66h55.135c9.697 0 9.697-15 0-15h-50.733c.106-1.187.169-2.386.169-3.6 0-.324 0-.681.001-1.058 14.554-2.01 26.744-11.512 32.554-24.472h18.009c9.697 0 9.697-15 0-15h-14.407c.035-.702.056-1.407.056-2.117v-15.437c19.585-3.546 34.485-20.723 34.485-41.314v-4.711c10.612-.98 19.059-9.527 19.889-20.181 4.545 5.39 7.193 12.3 7.193 19.596zm182.488-11.694H326.607c-11.669 0-22.325 4.429-30.373 11.693V238.752c0-16.748 13.625-30.373 30.373-30.373h120.762c9.018 0 16.354 7.336 16.354 16.354v225.869z" />
        </svg>
        <span>{{ $t("header.userMenu.help") }}</span>
      </div>
      </b-dropdown-item>
      <b-dropdown-item link-class="d-flex align-items-center p-0"
        v-if="!checkOutHome() && is_creator" href="https://brandme.la/brandme-academy/" target="_blank"
      >
        <div class="d-flex padding-nav-item">
          <div>
            <b-img :src="require('@/assets/images/svg/book-fair.svg')" class="image-icon-brandme-ia-drop"/>
          </div>
          <span>{{ $t("header.userMenu.schoolCreators") }}</span>
        </div>
      </b-dropdown-item>
      <b-dropdown-item link-class="d-flex align-items-center menu-dropdown" 
        v-if="!checkOutHome()" href="https://soporte.brandme.la/base-de-conocimientos/contacta-al-soporte-de-brandme" target="_blank"
      >
      <div class="d-flex">
        <svg
          class="image-icon-brandme-ia-drop support-icon"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          aria-hidden="true"
        >
          <g>
            <g>
              <path d="M470.919 37.252h-65.441c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h65.441c4.142 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z" />
              <path d="M368.316 52.252h7.977c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-7.977c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
              <path d="M368.316 87.484h102.604c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5H368.316c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
              <path d="M395.443 444.1c0-29.959-10.002-59.35-28.22-83.097l1.39-25.605c.946-17.43-12.886-32.176-30.478-32.176h-82.098c-3.777-2.669-6.068-7.004-6.068-11.686v-20.941c12.729-8.232 21.666-17.62 28.231-28.792h14.514c16.791 0 30.451-13.66 30.451-30.451v-56.012c0-9.447-5.465-17.798-13.638-21.749v-39.31c0-17.896-14.559-32.456-32.455-32.456h-.841c-.512 0-.928-.417-.928-.928 0-17.896-14.56-32.456-32.456-32.456h-79.429c-39.427 0-71.504 32.077-71.504 71.504v33.645c-8.172 3.951-13.638 12.302-13.638 21.749v28.486c0 13.328 10.843 24.171 24.171 24.171h9.682c2.506 21.196 12.449 40.554 28.023 54.012 3.654 3.158 7.433 5.979 11.32 8.499v21.028c0 4.668-2.3 9.004-6.094 11.686h-82.069c-17.456 0-31.431 14.61-30.477 32.176l1.39 25.605c-18.219 23.748-28.221 53.139-28.221 83.098v28.249c-3.729 4.179-6.001 9.684-6.001 15.712 0 13.028 10.599 23.626 23.627 23.626h354.19c13.028 0 23.627-10.599 23.627-23.626 0-6.028-2.272-11.533-6.001-15.711zm-15 0v20.483c-.863-.096-1.738-.149-2.626-.149h-16.208l4.233-77.99c9.493 17.631 14.601 37.494 14.601 57.656zm-73.047-292.422c.493 1.128.771 2.366.771 3.663v28.486c0 5.057-4.114 9.171-9.171 9.171h-8.919v-28.273l4.622-1.61c5.718-1.992 10.215-6.192 12.697-11.437zm-50.073 86.898h-18.822c-3.034 0-5.503-2.468-5.503-5.502s2.469-5.502 5.503-5.502h18.822c3.034 0 5.502 2.468 5.502 5.502s-2.468 5.502-5.502 5.502zm35.393-11.772h-7.581c2.112-6.022 3.57-12.33 4.339-18.806h9.522c3.245 0 6.341-.647 9.171-1.812v5.168c0 8.519-6.932 15.45-15.451 15.45zm-185.8-126.857c0-31.156 25.348-56.504 56.504-56.504h79.429c9.625 0 17.456 7.831 17.456 17.456 0 8.783 7.146 15.928 15.928 15.928h.841c9.625 0 17.455 7.831 17.455 17.456v47.963c0 3.018-1.915 5.712-4.765 6.705l-15.761 5.489c-.635.22-1.29-.238-1.29-.921l.029-29.804c.091-21.751-20.276-40.721-48.812-31.555-14.352 4.612-32.113 4.596-46.417 0-28.24-9.076-48.903 9.557-48.812 31.532l.035 29.829c0 .688-.67 1.141-1.29.919l-15.766-5.49c-2.85-.992-4.765-3.687-4.765-6.705v-42.298zm-13.638 83.88v-28.487c0-1.296.278-2.535.771-3.663 2.483 5.246 6.98 9.446 12.7 11.438l4.621 1.609v28.273h-8.92c-5.058.001-9.172-4.114-9.172-9.17zm33.229 15.508c-.249-9.86-.096-20.326-.138-29.908.462.04.925.063 1.388.063 8.917 0 15.994-7.248 15.979-15.991l-.035-29.848c-.051-12.178 10.873-23.109 29.223-17.211 17.392 5.588 38.26 5.571 55.595 0 17.483-5.617 29.277 4.272 29.223 17.236l-.029 29.825c-.012 9.296 7.934 16.744 17.362 15.926v30.515c-.218 6.482-1.285 12.808-3.095 18.824-3.725-3.816-8.916-6.195-14.657-6.195h-18.822c-11.305 0-20.503 9.197-20.503 20.502s9.198 20.502 20.503 20.502h9.529c-13.853 10.813-29.606 16.451-46.915 16.738-37.864-.303-73.525-28.276-74.608-70.978zm39.968 92.202v-13.123c10.841 4.489 22.406 6.815 34.62 6.901h.053c.039 0 .078 0 .117-.001 11.891-.185 23.149-2.489 33.707-6.839v13.061c0 4.095.857 8.059 2.435 11.686h-73.376c1.583-3.628 2.444-7.593 2.444-11.685zm-130.873 94.907 1.184 21.821c.225 4.137 3.768 7.318 7.895 7.083 4.136-.224 7.307-3.759 7.083-7.895l-3.955-72.867c-.481-8.864 6.553-16.363 15.5-16.363h274.827c8.881 0 15.984 7.432 15.5 16.363l-7.048 129.849h-117.608c1.433-8.567 5.291-16.625 11.234-23.227l.215-.24c22.702-25.398 15.907-65.114-13.437-81.788-7.53-4.278-17.093 1.057-17.093 9.926v34.03c0 1.56-1.269 2.828-2.829 2.828h-12.696c-1.56 0-2.829-1.269-2.829-2.828v-34.03c0-8.852-9.548-14.213-17.093-9.926-29.428 16.72-36.085 56.451-13.414 81.813l.192.215c5.943 6.601 9.801 14.659 11.234 23.226h-117.607l-1.203-22.173c-.224-4.136-3.759-7.311-7.895-7.083-4.136.224-7.307 3.759-7.083 7.895l1.159 21.361h-16.208c-.888 0-1.763.054-2.626.149v-20.483c0-20.161 5.109-40.025 14.601-57.656zm152.017 77.99c-1.535-12.289-6.803-23.89-15.239-33.261l-.181-.203c-14.491-16.21-12.55-41.277 4.347-55.102v27.267c0 9.831 7.998 17.828 17.829 17.828h12.696c9.831 0 17.829-7.998 17.829-17.828v-27.267c16.785 13.733 18.935 38.782 4.328 55.123l-.162.181c-8.437 9.372-13.705 20.973-15.24 33.262zm190.198 32.254h-354.19c-4.757 0-8.627-3.87-8.627-8.626s3.87-8.627 8.627-8.627h354.19c4.757 0 8.627 3.87 8.627 8.627s-3.87 8.626-8.627 8.626z" />
              <path d="M504.5 51.64c4.142 0 7.5-3.358 7.5-7.5V29.624c0-16.162-13.149-29.311-29.312-29.311H356.547c-16.163 0-29.312 13.149-29.312 29.311v63.088c0 16.163 13.149 29.312 29.312 29.312 2.888 0 5.238 2.35 5.238 5.238v39.015c0 5.635 3.648 10.431 9.079 11.934 5.463 1.512 11.043-.762 13.924-5.566l28.83-48.077c.941-1.569 2.663-2.544 4.493-2.544h64.578c16.163 0 29.312-13.149 29.312-29.312V44.14c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v13.508c0 7.892-6.42 14.312-14.312 14.312h-64.579c-7.07 0-13.721 3.767-17.357 9.83l-23.969 39.97v-29.562c0-11.159-9.079-20.238-20.238-20.238-7.892 0-14.312-6.42-14.312-14.312V29.624c0-7.891 6.42-14.311 14.312-14.311h126.142c7.892 0 14.312 6.42 14.312 14.311v14.516c0 4.142 3.358 7.5 7.5 7.5z" />
            </g>
          </g>
        </svg>
        <span>{{ $t("header.userMenu.suport") }}</span>
      </div>
      </b-dropdown-item>
      <b-dropdown-item link-class="d-flex align-items-center menu-dropdown"
        v-if="!checkOutHome()" href="https://soporte.brandme.la/base-de-conocimientos/solicitud-para-eliminar-contenido-en-brandme" target="_blank"
      >
        <div class="d-flex">
          <svg
            class="image-icon-brandme-ia-drop delete-content-icon"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M8.34 21H2c-1.103 0-2-.897-2-2V2c0-1.103.897-2 2-2h15c1.103 0 2 .897 2 2v5.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5V2c0-.551-.449-1-1-1H2C1.449 1 1 1.449 1 2v17c0 .551.449 1 1 1h6.34c.276 0 .5.224.5.5s-.224.5-.5.5z" />
            <path d="M18.5 6h-18c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h18c.276 0 .5.224.5.5s-.224.5-.5.5z" />
            <path d="M15.5 11h-15c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5z" />
            <path d="M9.5 16h-9c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h9c.276 0 .5.224.5.5s-.224.5-.5.5z" />
            <path d="M9.5 16c-.276 0-.5-.224-.5-.5v-10c0-.276.224-.5.5-.5s.5.224.5.5v10c0 .276-.224.5-.5.5z" />
            <path d="M15.429 24c-.401 0-.778-.156-1.061-.439l-3.535-3.536c-.283-.283-.439-.66-.439-1.061 0-.4.156-.777.439-1.061l7.071-7.071c.567-.566 1.556-.566 2.122 0l3.535 3.535c.283.284.439.661.439 1.062 0 .4-.156.777-.439 1.061l-7.071 7.071c-.283.283-.66.439-1.061.439zm-.354-1.146c.195.195.512.196.708 0l7.071-7.071c.195-.195.195-.512 0-.708l-3.536-3.535c-.188-.188-.517-.188-.707 0l-7.071 7.071c-.094.095-.146.22-.146.354s.052.259.146.353z" />
            <path d="M18.671 21.171c-.128 0-.256-.049-.354-.146l-4.95-4.95c-.195-.195-.195-.512 0-.707s.512-.195.707 0l4.95 4.95c.195.195.195.512 0 .707-.097.098-.225.146-.353.146z" />
          </svg>
          <span>{{ $t("header.userMenu.deleteContent") }}</span>
        </div>
      </b-dropdown-item>
      <b-dropdown-divider class="px-1"/>
      <b-dropdown-item link-class="d-flex align-items-center menu-dropdown" @click="logoutFunction">
        <feather-icon
          size="16"
          icon="LogOutIcon"
          class="mr-50"
          variant="light-primary"
        />
        <span>{{ $t("header.userMenu.logout") }}</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BButton,
  BCollapse,
  BImg,
  BBadge,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import useAppConfig from "@core/app-config/useAppConfig";
import { avatarText } from "@core/utils/filter";
import { avatar } from "@/assets/images/avatars/usuario.png";
import service_profile from '@/services/others'
import { getSummaryCredits } from '@/services/ia'
import { separatebycomma, capitalize } from '@/libs/utils/formats';
import { getUserData, logout } from '@/libs/utils/user';
import { daysUntil } from '@/libs/utils/times'
import store from '@/store'
import { verifyAsset, } from '@/libs/utils/urls'
import { languajesPlatform} from '@/services/settings';

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
    BCollapse,
    BImg,
    BBadge,
  },
  data() {
    return {
      verifyAsset,
      getUserData,
      capitalize,
      separatebycomma,
      avatarText,
      credits: 0,
      visible: false,
      avatar,
      check: false,
      domain_path: window.location.host,
      userData: JSON.parse(localStorage.getItem('userData')),
      max_view: 0,
      is_creator: false
    }
  },
  setup() {
    const locales = {
      en: {
        locale: 'en',
        img: require(`@/assets/images/countries/us.svg`),
        name: 'English',
      },
      es: {
        locale: 'es',
        img: require(`@/assets/images/countries/mx.svg`),
        name: 'Español',
      },
      // Agrega más idiomas según sea necesario
    };

    const { isDropdownMenuHidden } = useAppConfig();

    return {
      locales,
      isDropdownMenuHidden,
    };
  },
  computed: {
    period_trial() {
      const period = store.getters['main_store/trial_period'];
      const days = daysUntil(period.current_period_end)

      if (!period.trial) return ''
      else return {text: `( ${this.$t('trialOf')} ${days} ${this.$t('preview.days')})`, number: days}
    }
  },
  created() {
    this.$root.$on('profile_update', () => {
      this.userData = JSON.parse(localStorage.getItem('userData'));
    });
    this.$root.$on('change_max_views', (max_views) => {
      this.max_view = max_views;
    })
    this.$root.$on('update_credits_drop', (consumed_credits) => {
      this.credits = this.credits - consumed_credits;
    })
    this.getSummaryCredits();
    if (this.userData?.main_group?.name && this.userData.main_group.name !== 'creator') {
      this.getMaxViews();
    }
    if (this.userData?.main_group?.name && this.userData.main_group.name === 'creator') {
      this.is_creator = true
    }
  },
  methods: {
    plan() {
      return getUserData() && getUserData().current_plan ? getUserData().current_plan : null;
    },
    getNameRol() {
      const user = getUserData();
      const is_user_agency = user?.user_permissions?.some(permission => permission.codename === 'user_agency');
      
      if (is_user_agency) return this.$t('creator.talentAgency');

      const name = `${this.$t(`creator.displayNameMembership.${this.plan()?.display_name}`)}`
      return name;
    },
    getSummaryCredits() {
      getSummaryCredits().then((response) => {
        this.credits = response.credits_available;
        const update_img = { profile_image: response.profile_image };
        const updated_data = { ...this.userData, ...update_img };
        localStorage.setItem('userData', JSON.stringify(updated_data));
        this.userData = updated_data;
      })
    },
    getMaxViews() {
      service_profile.getMaxViews().then(response => {
        this.max_view = response.max_views;
      })
    },
    changeLanguage(locale) {
      this.$i18n.locale = locale;
      
      const formData = new FormData()
      formData.append("language_platform", locale)
      
      languajesPlatform(formData).then(() => {
        const userData = getUserData();
        userData.language_platform = locale;
        localStorage.setItem('userData', JSON.stringify(userData));
      })
      this.visible = false
    },
    redirectEmail() {
      const userData = getUserData()
      if (userData && userData.main_group.name === 'creator') {
        if (userData.meta_info && userData.meta_info.vanity_name) {
          this.$router.push({ name: 'user_profile', params: { user: userData.meta_info.vanity_name } });
        } else {
          this.$router.push({ name: 'setting-public-profile', params: { section: 'connections' } });
        }
      } else {
        this.$router.push({ name: 'pages-account-setting', params: { section: 'general'} });
      }

    },
    logoutFunction() {
      // Reset ability
      this.$ability.update(initialAbility);
      logout();
    },
    openChatSupport() {
      this.$root.$emit('open_chat_hubspot')
    },
    status() {
      this.$router.push({ name: "status" });
    },
    isSuperUser() {
      return getUserData().is_superuser
    },
    showStatus() {
      const userData = JSON.parse(localStorage.getItem('userData'));
      if (userData && userData.main_group && userData.main_group.name) return userData.main_group.name !== 'creator';
      return false
    },
    checkOutHome() {
      return this.domain_path.includes('outofhome')
    }
  },
}
</script>
<style scoped lang="scss">
.padding-nav-item {
  padding: 9.1px 17.9px;
}
.image-icon-brandme-ia-drop {
  width: 20px;
  height: 20px;
  margin-right: 0.5em;
}
.container-email {
  font-size: small;
  height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  font-family: 'avenir-light';
}
.container-username {
  font-weight: bold;
  height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}

</style>
<style lang="scss">
.user-nav {
  color: var(--header-text);
  .user-name-main-navbar-up {
    @media(max-width: 1199px) {
      max-width: 150px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
  #dropdown-user-menu-purple .dropdown-menu {
    overflow-y: scroll;
    max-height: 80vh;
    
  }

.ml-07 {
  margin-left: 7px;
}
.custom-drop {
  color: #212529;
  font-weight: bold;
  border-radius:0px;
  width: 100%;
  padding: 0.786rem 1.1rem;
;
}
.custom-drop:hover {
  color: var(--brand-primary);
  background-color: var(--primary-subtle-bg);
  font-weight: bold;
  border-radius:0px;
  width: 100%;
}
.menu-dropdown {
  color: #212529;
}
.menu-dropdown:hover,
.menu-dropdown:focus,
.menu-dropdown:active,
.padding-nav-item:hover,
.padding-nav-item:focus,
.padding-nav-item:active {
  color: var(--brand-primary) !important;
  background-color: var(--primary-subtle-bg);
}
.container-submenu {
  height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: bold;
  overflow: hidden;
}
.size-submenu {
  width: 240px !important;
  height: auto;
}
</style>

